import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

// Intent belongs to the message, not to a particular translation response.
// Record it before requesting so background completion can show the result.
export function useTranslationExpansion(context, translation, options = {}) {
  const route = useRoute();
  const wantsTranslation = ref(false);
  let confirmedDigest = options.sourceDigest?.value || '';
  const translationExpanded = computed(
    () => wantsTranslation.value && Boolean(translation.value?.trim())
  );
  const scope = computed(() =>
    JSON.stringify([
      route.params.accountId,
      context.conversationId.value,
      context.id.value,
      context.content.value,
    ])
  );
  watch(scope, () => {
    wantsTranslation.value = false;
    confirmedDigest = options.sourceDigest?.value || '';
  }, { flush: 'sync' });

  // Parser initialization/version changes are metadata. Only a confirmed
  // change between original-source digests invalidates the user's intent.
  if (options.sourceDigest) {
    watch(options.sourceDigest, next => {
      if (!next) return;
      if (confirmedDigest && confirmedDigest !== next) wantsTranslation.value = false;
      confirmedDigest = next;
    }, { flush: 'sync' });
  }

  return {
    translationExpanded,
    expandTranslation: () => { wantsTranslation.value = true; },
    toggleTranslation: () => { wantsTranslation.value = !wantsTranslation.value; },
  };
}
